var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.038 14.987c-111.358-6.761-222.716-6.761-334.074 0-44.664 2.712-80.381 37.934-84.081 82.528-6.507 78.427-6.507 156.853-.002 235.28 3.706 44.672 39.542 79.845 84.287 82.544 17.761 1.071 35.522 1.971 53.283 2.702 9.942.409 19.359 4.572 26.395 11.608l62.028 62.027c13.878 13.878 36.379 13.878 50.257 0l62.028-62.027c7.036-7.036 16.453-11.198 26.395-11.608 17.761-.731 35.522-1.63 53.282-2.702 44.744-2.699 80.581-37.871 84.287-82.543 6.506-78.427 6.505-156.853-.002-235.28-3.702-44.595-39.419-79.817-84.083-82.529z",
    fill: "#9dc6fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.222 501.689c-10.745 1.597-22.077-1.741-30.349-10.014l-62.027-62.027c-7.036-7.036-16.452-11.198-26.393-11.61-17.76-.721-35.52-1.628-53.281-2.699-44.751-2.699-80.58-37.869-84.289-82.538-6.511-78.427-6.511-156.855 0-235.282 3.533-42.598 36.283-76.645 78.139-81.971-29.123 13.032-50.417 46.131-53.095 81.971-5.851 78.427-5.851 156.855 0 235.282 3.338 44.669 35.603 79.839 75.883 82.538 15.988 1.071 47.429 1.978 63.418 2.699 8.952.412 17.431 4.574 23.766 11.61l55.836 62.027c5.047 5.604 8.838 8.942 12.392 10.014z",
    fill: "#80b4fb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m285.597 216.159 119.364 68.915c15.501 8.949 34.876-2.237 34.876-20.136v-97.558c0-17.899-19.376-29.085-34.876-20.136z",
    fill: "#21386b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.578 315.199c-57.659 3.475-115.319 3.475-172.978 0-21.736-1.31-39.209-18.39-41.078-40.086-3.386-39.303-3.386-78.606 0-117.908 1.869-21.695 19.342-38.775 41.078-40.086 57.659-3.475 115.319-3.475 172.978 0 21.736 1.31 39.209 18.39 41.078 40.086 3.386 39.303 3.386 78.606 0 117.908-1.869 21.696-19.342 38.776-41.078 40.086z",
    fill: "#26457d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.66 275.135c-1.885 21.675-19.357 38.745-41.083 40.064-57.659 3.472-115.318 3.472-172.977 0-21.727-1.319-39.198-18.389-41.073-40.064 7.84 3.544 17.544 5.769 28.134 6.14 66.281 2.277 132.573 2.277 198.855 0 10.59-.37 20.305-2.596 28.144-6.14z",
    fill: "#21386b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.845 201.2-46.035-26.579c-11.516-6.649-25.91 1.662-25.91 14.959v53.157c0 13.297 14.395 21.608 25.91 14.959l46.035-26.579c11.516-6.647 11.516-23.268 0-29.917z",
    fill: "#ee596b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcons);
export default __webpack_public_path__ + "static/media/video-icons.266214e14a4273032a0f9d46d2691768.svg";
export { ForwardRef as ReactComponent };